/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var HandPointButtonIcon20Solid = forwardRef('HandPointButtonIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M2 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-3V6a2.5 2.5 0 0 0-5 0v2H4a2 2 0 0 1-2-2V4Z" }),
        React.createElement("path", { d: "M8.84 19.002h4.348a1.65 1.65 0 0 0 1.605-1.264l1.08-4.491a2.25 2.25 0 0 0-1.804-2.743L10 9.8V6a1.5 1.5 0 0 0-3 0v7.13l-1.87-1.166a1.61 1.61 0 0 0-1.924 2.565l4.534 4.052c.303.27.694.42 1.1.42Z" })));
});
